import React from 'react';
import { useTranslation } from "react-i18next";
import translations from "../../../utils/language/translations.json";

const Blog = () => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.FooterBlog[key][currentLang];

  return (
    <section className="grid">
      <div className="contentfront">
        <div className="page-content blog-page">
          <h1>{t("title")}</h1>
          <p>{t("intro")}</p>

          <ul className="styled-bullets">
            <li>📈 {t("point1")}</li>
            <li>🎤 {t("point2")}</li>
            <li>🧪 {t("point3")}</li>
            <li>🛠️ {t("point4")}</li>
          </ul>

          <div className="coming-soon-box">
            <h2>{t("comingSoon")}</h2>
            <p>{t("cta")}</p>
<button className="cta-contribute">{t("ctaButton")}</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
